import React from 'react';
// eslint-disable-next-line no-restricted-imports
import ThreadsIconButton, { Props } from 'plaid-threads/IconButton';

const IconButton: React.FC<Props> = (props) => {
  return <ThreadsIconButton {...props} />;
};

export default IconButton;
